import { jsx as a } from "react/jsx-runtime";
import c from "clsx";
import '../../assets/text.css';const T = "_type_1iusn_1", e = {
  type: T,
  "type--align-center": "_type--align-center_1iusn_8",
  "type--align-center-sm": "_type--align-center-sm_1iusn_12",
  "type--color-default": "_type--color-default_1iusn_16",
  "type--color-success": "_type--color-success_1iusn_24",
  "type--color-error": "_type--color-error_1iusn_28",
  "type--color-warning": "_type--color-warning_1iusn_32",
  "type--color-info": "_type--color-info_1iusn_36",
  "type--size-T900": "_type--size-T900_1iusn_40",
  "type--size-T800": "_type--size-T800_1iusn_45",
  "type--size-T700": "_type--size-T700_1iusn_50",
  "type--size-T600": "_type--size-T600_1iusn_55",
  "type--size-T500": "_type--size-T500_1iusn_60",
  "type--size-T400": "_type--size-T400_1iusn_65",
  "type--size-T300": "_type--size-T300_1iusn_70",
  "type--size-T200": "_type--size-T200_1iusn_75",
  "type--weight-light": "_type--weight-light_1iusn_80",
  "type--weight-regular": "_type--weight-regular_1iusn_84",
  "type--weight-medium": "_type--weight-medium_1iusn_88",
  "type--weight-bold": "_type--weight-bold_1iusn_92",
  "type--weight-heavy": "_type--weight-heavy_1iusn_96",
  "type--style-italic": "_type--style-italic_1iusn_105",
  "type--text-decoration-underline": "_type--text-decoration-underline_1iusn_109",
  "type--text-decoration-strikethrough": "_type--text-decoration-strikethrough_1iusn_114",
  "type--margin-bottom": "_type--margin-bottom_1iusn_119",
  "type--transform-uppercase": "_type--transform-uppercase_1iusn_123",
  "type--transform-capitalize": "_type--transform-capitalize_1iusn_127",
  "type--transform-lowercase": "_type--transform-lowercase_1iusn_131",
  "type--color-inherit": "_type--color-inherit_1iusn_146",
  "type--color-light": "_type--color-light_1iusn_150",
  "type--color-dark": "_type--color-dark_1iusn_154",
  "type--line-height-900": "_type--line-height-900_1iusn_174",
  "type--line-height-800": "_type--line-height-800_1iusn_178",
  "type--line-height-700": "_type--line-height-700_1iusn_182",
  "type--line-height-600": "_type--line-height-600_1iusn_186",
  "type--line-height-500": "_type--line-height-500_1iusn_190",
  "type--line-height-400": "_type--line-height-400_1iusn_194",
  "type--line-height-300": "_type--line-height-300_1iusn_198",
  "type--line-height-200-med": "_type--line-height-200-med_1iusn_202",
  "type--line-height-200": "_type--line-height-200_1iusn_202",
  "type--line-height-100-med": "_type--line-height-100-med_1iusn_210",
  "type--line-height-100": "_type--line-height-100_1iusn_210",
  "type--align-right": "_type--align-right_1iusn_218"
}, z = ({
  as: s = "p",
  size: i = "T300",
  lineHeight: t,
  weight: y,
  align: _,
  italic: h,
  color: p,
  transform: n,
  decoration: r,
  marginBottom: l,
  children: o,
  className: u,
  ...g
}) => /* @__PURE__ */ a(
  s,
  {
    className: c(
      {
        [e.type]: !0,
        [e["type--align-center"]]: _ === "center",
        [e["type--align-center-sm"]]: _ === "center-sm",
        [e["type--align-right"]]: _ === "right",
        [e["type--style-italic"]]: h,
        [e["type--color-default"]]: p === "default",
        [e["type--color-inherit"]]: p === "inherit",
        [e["type--color-success"]]: p === "success",
        [e["type--color-error"]]: p === "error",
        [e["type--color-warning"]]: p === "warning",
        [e["type--color-info"]]: p === "info",
        [e["type--color-light"]]: p === "light",
        [e["type--color-dark"]]: p === "dark",
        [e["type--transform-uppercase"]]: n === "uppercase",
        [e["type--transform-lowercase"]]: n === "lowercase",
        [e["type--transform-capitalize"]]: n === "capitalize",
        [e["type--text-decoration-underline"]]: r === "underline",
        [e["type--text-decoration-strikethrough"]]: r === "strikethrough",
        [e["type--size-T900"]]: i === "T900",
        [e["type--size-T800"]]: i === "T800",
        [e["type--size-T700"]]: i === "T700",
        [e["type--size-T600"]]: i === "T600",
        [e["type--size-T500"]]: i === "T500",
        [e["type--size-T400"]]: i === "T400",
        [e["type--size-T300"]]: i === "T300",
        [e["type--size-T200"]]: i === "T200",
        [e["type--line-height-900"]]: t === "T900",
        [e["type--line-height-800"]]: t === "T800",
        [e["type--line-height-700"]]: t === "T700",
        [e["type--line-height-600"]]: t === "T600",
        [e["type--line-height-500"]]: t === "T500",
        [e["type--line-height-400"]]: t === "T400",
        [e["type--line-height-300"]]: t === "T300",
        [e["type--line-height-200-med"]]: t === "T200-med",
        [e["type--line-height-200"]]: t === "T200",
        [e["type--line-height-100-med"]]: t === "T100-med",
        [e["type--line-height-100"]]: t === "T100",
        [e["type--weight-light"]]: y === "light",
        [e["type--weight-regular"]]: y === "regular",
        [e["type--weight-medium"]]: y === "medium",
        [e["type--weight-bold"]]: y === "bold",
        [e["type--weight-heavy"]]: y === "heavy",
        [e["type--margin-bottom"]]: l
      },
      u
    ),
    ...g,
    children: o
  }
);
export {
  z as Text
};
